import holiday from '@/api/holiday-rule'

import { baseState } from '@/store/mixins'

export const state = {
  ...baseState,
  holiday_rule_resources: [],
  substitutes: []
}

export const getters = {}

export const mutations = {
  RECEIVE_SUBSTITUTE(state, data) {
    state.substitutes = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return holiday.get().then(response => {
      return Promise.resolve(response.data)
    })
  },

  store(context, data) {
    return holiday.store(data)
  },

  update(context, data) {
    return holiday.update(data)
  },

  async dataBeforeCreate(context) {
    let substitute = await holiday.getSubstitute()
    context.commit('RECEIVE_SUBSTITUTE', substitute)
  }
}
